import React, { useEffect } from 'react';
import styles from './NotFound.module.css';

const NotFound = () => {
  useEffect(() => {
    // Create random stars
    const createStars = () => {
      const stars = document.getElementById('stars');
      const starsCount = 100;
      
      if (stars) {
        for (let i = 0; i < starsCount; i++) {
          const star = document.createElement('div');
          star.classList.add(styles.star);
          
          // Random position
          const posX = Math.floor(Math.random() * window.innerWidth);
          const posY = Math.floor(Math.random() * window.innerHeight);
          
          // Random size
          const size = Math.random() * 3;
          
          // Random animation delay
          const delay = Math.random() * 3;
          
          star.style.left = `${posX}px`;
          star.style.top = `${posY}px`;
          star.style.width = `${size}px`;
          star.style.height = `${size}px`;
          star.style.animationDelay = `${delay}s`;
          
          stars.appendChild(star);
        }
      }
    };
    
    // Call function when component mounts
    createStars();
    
    // Cleanup when component unmounts
    return () => {
      const stars = document.getElementById('stars');
      if (stars) {
        while (stars.firstChild) {
          stars.removeChild(stars.firstChild);
        }
      }
    };
  }, []);

  return (
    <div className={styles.body}>
      <div className={styles.stars} id="stars"></div>
      <div className={styles.container}>
        <h1 className={styles.errorCode}>404</h1>
        <h2 className={styles.title}>Page Not Found</h2>
        <p className={styles.message}>
          Oops! The page you're looking for seems to have wandered off into space. 
          It might have been moved, deleted, or never existed in the first place.
        </p>
        <a href="/" className={styles.homeButton}>Back to Home</a>
        <a href="/contact" className={styles.searchButton}>support@clotechai.com</a>
      </div>
      <div className={styles.astronaut}>
        <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M145 90C145 116.51 123.51 138 97 138C70.49 138 49 116.51 49 90C49 63.49 70.49 42 97 42C123.51 42 145 63.49 145 90Z" fill="#F5F7FA" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M97 60C95 60 80 62 75 90C70 118 85 126 97 126C109 126 124 118 119 90C114 62 99 60 97 60Z" fill="var(--primary)" fillOpacity="0.1"/>
          <circle cx="97" cy="90" r="30" fill="#F5F7FA" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M120 155L115 138H79L74 155H120Z" fill="#F5F7FA" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M97 138V155" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M76 100L68 108" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M118 100L126 108" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M97 80V95" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M87 90H107" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M85 120L82 127" stroke="var(--primary)" strokeWidth="4"/>
          <path d="M109 120L112 127" stroke="var(--primary)" strokeWidth="4"/>
        </svg>
      </div>
    </div>
  );
};

export default NotFound;